import React from 'react';
import { ContactDetailField, useGetRenderContactDetailsFormFields } from '../ContactDetailsForm';
import { getIntl } from '../../../utils/intl';
import { FormStack } from '../../v2BaseComponents/Stack';
import { SplitFormRow } from '../../v2BaseComponents/Form';
import { Field } from 'formik';
import { FormikInputs } from '../../v2BaseComponents/Inputs';
import { required } from '../../../utils/validators';

const intl = getIntl('group-fields', {
    name: 'Name',
    description: 'Description',
});

export type GroupFieldsOwnProps = {
    isDisabled: boolean;
};

export type GroupFieldsProps = GroupFieldsOwnProps;

const contactDetailsFields: ContactDetailField[] = ['address1', 'address2', 'city', 'state', 'zipCode'];

const GroupFields: React.FC<GroupFieldsProps> = (props) => {
    const { renderFields } = useGetRenderContactDetailsFormFields({
        isDisabled: props.isDisabled,
        fields: contactDetailsFields,
    });
    return (
        <FormStack>
            <SplitFormRow>
                <Field name="name" title={intl('name')} component={FormikInputs.Input} isRequired validate={required} />
                <Field name="description" title={intl('description')} component={FormikInputs.Input} />
            </SplitFormRow>
            {renderFields()}
        </FormStack>
    );
};

export default React.memo(GroupFields);
